/** Application entry point. */

import { initApp } from './app';
import './styles/main.css';

// Initialize the application
initApp();

